export default class Component {
  constructor(props) {
    this._element = props.element;
    this._state = { ...props.initialState };
    this._props = {};

    this.setProps(props);
  }

  _setState(newState) {
    this._state = {
      ...this._state,
      ...newState,
    };
    this._updateView(this._props, this._state);
  }

  setProps(newProps) {
    this._props = {
      ...this._props,
      ...newProps,
    };

    this._updateView(this._props, this._state);
  }

  _updateView() {}

  init() {}
}
